import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import DockDirection from './dockDirection';
import RadioButtons from '../radioButtons';
var DIRECTIONS = {
  TOP_LEFT: 'TOP_LEFT',
  TOP: 'TOP',
  TOP_RIGHT: 'TOP_RIGHT',
  LEFT: 'LEFT',
  MIDDLE: 'MIDDLE',
  RIGHT: 'RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM: 'BOTTOM',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};
var DOCK_DIRECTIONS_PROPS = [{
  className: 'top left',
  value: DIRECTIONS.TOP_LEFT
}, {
  className: 'top',
  value: DIRECTIONS.TOP
}, {
  className: 'top right',
  value: DIRECTIONS.TOP_RIGHT
}, {
  className: 'left',
  value: DIRECTIONS.LEFT
}, {
  className: 'middle',
  value: DIRECTIONS.MIDDLE
}, {
  className: 'right',
  value: DIRECTIONS.RIGHT
}, {
  className: 'bottom left',
  value: DIRECTIONS.BOTTOM_LEFT
}, {
  className: 'bottom',
  value: DIRECTIONS.BOTTOM
}, {
  className: 'bottom right',
  value: DIRECTIONS.BOTTOM_RIGHT
}];

var Dock = /*#__PURE__*/function (_React$Component) {
  _inherits(Dock, _React$Component);

  var _super = _createSuper(Dock);

  function Dock() {
    var _this;

    _classCallCheck(this, Dock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "generateDockDirections", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          disabledDirections = _this$props.disabledDirections,
          onDirectionMouseEnter = _this$props.onDirectionMouseEnter,
          onDirectionMouseLeave = _this$props.onDirectionMouseLeave;
      return DOCK_DIRECTIONS_PROPS.map(function (itemProps, index) {
        return /*#__PURE__*/React.createElement(DockDirection, {
          className: itemProps.className,
          value: itemProps.value,
          disabled: disabled || disabledDirections.includes(itemProps.value),
          onMouseEnter: onDirectionMouseEnter,
          onMouseLeave: onDirectionMouseLeave,
          key: "dockDirection".concat(index)
        });
      });
    });

    return _this;
  }

  _createClass(Dock, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-dock' + (this.props.disabled ? ' disabled' : ''))
      }, /*#__PURE__*/React.createElement(RadioButtons, {
        value: this.props.value,
        showRadioSymbol: false,
        orientation: "horizontal",
        onChange: this.props.onChange
      }, this.generateDockDirections()), /*#__PURE__*/React.createElement("div", {
        className: "grid horizontal"
      }), /*#__PURE__*/React.createElement("div", {
        className: "grid vertical"
      }));
    }
  }]);

  return Dock;
}(React.Component);

Dock.displayName = 'Dock';
Dock.propTypes = {
  /** Callback function `(direction) => {}`, triggered when the user clicks on a direction */
  onChange: PropTypes.func.isRequired,

  /** The selected direction value */
  value: PropTypes.oneOf(['TOP_LEFT', 'TOP', 'TOP_RIGHT', 'LEFT', 'MIDDLE', 'RIGHT', 'BOTTOM_LEFT', 'BOTTOM', 'BOTTOM_RIGHT']),

  /** Callback function `(direction) => {}`, triggered when the user hovers over a direction */
  onDirectionMouseEnter: PropTypes.func,

  /** Callback function `(direction) => {}`, triggered when the user moves the cursor so that it is no longer contained within a direction */
  onDirectionMouseLeave: PropTypes.func,

  /** List of disabled directions that are blocked from being selected. */
  disabledDirections: PropTypes.arrayOf(PropTypes.oneOf(['TOP_LEFT', 'TOP', 'TOP_RIGHT', 'LEFT', 'MIDDLE', 'RIGHT', 'BOTTOM_LEFT', 'BOTTOM', 'BOTTOM_RIGHT'])),

  /** Indicates weather the control should be disabled or not */
  disabled: PropTypes.bool
};
Dock.defaultProps = {
  disabled: false,
  disabledDirections: []
};
export default compose(Dock);